export default {
  VIDEO: "Video",
  VIDEOS: "Videos",
  ACTIVITY: "Activity",
  ACTIVITIES: "Activities",
  TOPIC: "Topic",
  CHANNEL: "Channel",
  TAG: "Tag",
  TAGS: "Content Tags",
  CUSTOM_LINK: "Custom Link",
  BLOG_POST: "Blog Post",
};
